module.exports = __webpack_public_path__ + "img/popcorn.5699e247.gif";